import { hasHelpStaffPermissions } from './permissions';

export const SUPPORT_GROUP_SUBSCRIPTION_STATUSES = ['ACTIVE', 'PAUSED', 'PHARMACY_CHANGED'];
export const SUPPORT_GROUP_PROGRAM_SLUGS = new Set(['wl', 'gmd']);
export const SUPPORT_GROUP_PRODUCT_SKUS = new Set([
	'SEMAGLUTIDE-G',
	'TIRZEPATIDE-G',
	'OZEMPIC',
	'ZEPBOUND',
	'SEMAGLUTIDE-G-MICRODOSING',
	'TIRZEPATIDE-G-MICRODOSING',
]);

export const hasActiveSupportGroupsSubscription = ({ subscriptions = [], programs = [] } = {}) => {
	return subscriptions.some((subscription) => (
		SUPPORT_GROUP_SUBSCRIPTION_STATUSES.includes(subscription?.status)
		&& (
			SUPPORT_GROUP_PROGRAM_SLUGS.has(programs.find((program) => program?.id === subscription?.programId)?.slug)
			|| SUPPORT_GROUP_PRODUCT_SKUS.has(subscription?.productSku)
		)
	));
};

export const getSupportGroupsAccessDecision = ({ authContext, subscriptions = [], programs = [] } = {}) => {
	const subscriptionSummaries = subscriptions.map((subscription) => {
		const enrolledProgram = programs.find((program) => program?.id === subscription?.programId);
		const isActiveStatus = SUPPORT_GROUP_SUBSCRIPTION_STATUSES.includes(subscription?.status);
		const isSupportGroupsProgram = SUPPORT_GROUP_PROGRAM_SLUGS.has(enrolledProgram?.slug);
		const isSupportGroupsProduct = SUPPORT_GROUP_PRODUCT_SKUS.has(subscription?.productSku);

		return {
			id: subscription?.id ?? null,
			status: subscription?.status ?? null,
			programId: subscription?.programId ?? null,
			programSlug: enrolledProgram?.slug ?? null,
			productSku: subscription?.productSku ?? null,
			isActiveStatus,
			isSupportGroupsProgram,
			isSupportGroupsProduct,
			grantsAccess: isActiveStatus && (isSupportGroupsProgram || isSupportGroupsProduct),
		};
	});
	const hasActiveSupportGroupsSubscription = subscriptionSummaries.some((subscription) => subscription.grantsAccess);
	// support staff only: hasAllStaffPermissions also admits reps and marketing managers, who have
	// no support remit in a patient peer-support space.
	const isSupportStaff = hasHelpStaffPermissions(authContext);

	return {
		canAccess: hasActiveSupportGroupsSubscription || isSupportStaff,
		hasActiveSupportGroupsSubscription,
		isSupportStaff,
		authFlags: {
			isRep: authContext?.isRep ?? false,
			isHelpStaff: authContext?.isHelpStaff ?? false,
			isStaffManager: authContext?.isStaffManager ?? false,
			isMarketingManager: authContext?.isMarketingManager ?? false,
			isAdmin: authContext?.isAdmin ?? false,
			isSuperAdmin: authContext?.isSuperAdmin ?? false,
		},
		subscriptionSummaries,
	};
};

export const canAccessSupportGroups = ({ authContext, subscriptions = [], programs = [] } = {}) => {
	return getSupportGroupsAccessDecision({ authContext, subscriptions, programs }).canAccess;
};
